<div class="surface-card available-float-card">
    <div class="section-label available-float-label">Available Float</div>

    <div class="available-float-value">
        @if (unavailable || balance == null) {
            <span class="data-unavailable">{{ unavailableText }}</span>
        } @else {
            {{ balance }}
        }
    </div>

    <!-- Minimum-threshold gauge and since-yesterday delta await their endpoints; placeholder until then. -->
    <div class="available-float-secondary">
        <span class="data-unavailable">Minimum threshold unavailable</span>
    </div>
    <div class="available-float-secondary">
        <span class="data-unavailable">Change since yesterday unavailable</span>
    </div>

    <button (click)="topUp.emit()" class="navy-btn available-float-top-up" type="button">Top Up Float</button>
</div>
